import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

// Guards
import { AuthGuard } from './_guards/auth.guard';

// Resolvers
import { AdminResolver } from './_resolvers/admin.resolver';
import { GroupResolver } from './_resolvers/group.resolver';
import { OwnerResolver } from './_resolvers/owner.resolver';

// Layouts
import { ExtLayoutComponent } from './layouts/ext-layout/ext-layout.component';
import { SuperLayoutComponent } from './layouts/super-layout/super-layout.component';
import { OwnerLayoutComponent } from './layouts/owner-layout/owner-layout.component';
import { GroupLayoutComponent } from './layouts/group-layout/group-layout.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/signin',
        pathMatch: 'full',
    }, {
        path: '',
        component: ExtLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './layouts/ext-layout/ext-layout.module#ExtLayoutModule'
            }]
    },
    {
        path: 'super',
        resolve: { AdminResolver },
        canActivate: [AuthGuard],
        component: SuperLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './layouts/super-layout/super-layout.module#SuperLayoutModule'
            }]
    },
    {
        path: 'group',
        resolve: { GroupResolver },
        canActivate: [AuthGuard],
        component: GroupLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './layouts/group-layout/group-layout.module#GroupLayoutModule'
            }]
    },
    {
        path: 'owner',
        resolve: { OwnerResolver },
        canActivate: [AuthGuard],
        component: OwnerLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './layouts/owner-layout/owner-layout.module#OwnerLayoutModule'
            }]
    },
    {
        path: '**',
        redirectTo: '/not_found'
    }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes)
    ],
    exports: [
    ],
    providers: [
        GroupResolver,
        AdminResolver,
        OwnerResolver
    ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts